/* SK Producto - Galeria + Cantidad + Variantes */
(function () {
  'use strict';

  /* Formatea centimos segun el money_format de la tienda (mismo resultado que el
     filtro | money de Liquid). Soporta los placeholders habituales de Shopify. */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') { cents = cents.replace(/[^0-9.-]/g, ''); }
    cents = parseInt(cents, 10);
    if (isNaN(cents)) return '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var frac = parts[1] ? (decimal + parts[1]) : '';
      return whole + frac;
    }

    var match = format.match(placeholder);
    var name = match ? match[1] : 'amount';
    var value;
    switch (name) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ''); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  function initSection(container) {
    /* R45: guard contra doble inicializacion */
    if (container.dataset.skInit) return;
    container.dataset.skInit = 'true';

    /* R46: SIEMPRE buscar dentro del container */
    var images = container.querySelectorAll('.sk-product__image');
    var thumbs = container.querySelectorAll('.sk-product__thumb');
    var prevBtn = container.querySelector('.sk-product__arrow--prev');
    var nextBtn = container.querySelector('.sk-product__arrow--next');
    var pills = container.querySelectorAll('.sk-product__variant-pill:not([aria-disabled="true"])');
    var priceEl = container.querySelector('[data-product-price]');
    var comparePriceEl = container.querySelector('[data-product-compare-price]');
    var variantInput = container.querySelector('[data-variant-input]');
    var addToCartBtn = container.querySelector('.sk-product__add-to-cart');
    var qtyInput = container.querySelector('.sk-product__qty-input');
    var minusBtn = container.querySelector('.sk-product__qty-btn--minus');
    var plusBtn = container.querySelector('.sk-product__qty-btn--plus');
    var mainImageWrap = container.querySelector('.sk-product__main-image');

    /* === PRECIO SEGUN CANTIDAD === */
    var moneyFormat = container.dataset.moneyFormat || '{{amount}}';
    var unitCents = priceEl ? parseInt(priceEl.dataset.unitPrice, 10) : NaN;
    var compareCents = comparePriceEl ? parseInt(comparePriceEl.dataset.unitCompare, 10) : NaN;

    /* Recalcula el precio mostrado = precio unitario x cantidad */
    function updateTotal() {
      if (!priceEl || isNaN(unitCents)) return;
      var qty = parseInt(qtyInput && qtyInput.value, 10);
      if (isNaN(qty) || qty < 1) qty = 1;
      priceEl.textContent = formatMoney(unitCents * qty, moneyFormat);
      if (comparePriceEl && !isNaN(compareCents)) {
        comparePriceEl.innerHTML = '<s>' + formatMoney(compareCents * qty, moneyFormat) + '</s>';
      }
    }

    var currentIndex = 0;
    var totalImages = images.length;

    /* === GALERIA DE IMAGENES === */

    function showImage(index) {
      if (totalImages === 0) return;
      /* Normalizar indice circular */
      if (index < 0) index = totalImages - 1;
      if (index >= totalImages) index = 0;
      currentIndex = index;

      for (var i = 0; i < images.length; i++) {
        if (i === currentIndex) {
          images[i].classList.add('sk-product__image--active');
        } else {
          images[i].classList.remove('sk-product__image--active');
        }
      }

      for (var j = 0; j < thumbs.length; j++) {
        if (j === currentIndex) {
          thumbs[j].classList.add('sk-product__thumb--active');
        } else {
          thumbs[j].classList.remove('sk-product__thumb--active');
        }
      }

      /* Scroll del carrusel de thumbs para mostrar el activo */
      var thumbsContainer = container.querySelector('.sk-product__thumbs');
      if (thumbsContainer && thumbs[currentIndex]) {
        var cRect = thumbsContainer.getBoundingClientRect();
        var tRect = thumbs[currentIndex].getBoundingClientRect();

        if (tRect.left < cRect.left) {
          thumbsContainer.scrollLeft -= (cRect.left - tRect.left);
        } else if (tRect.right > cRect.right) {
          thumbsContainer.scrollLeft += (tRect.right - cRect.right);
        }
      }
    }

    /* Flechas prev/next */
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        showImage(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        showImage(currentIndex + 1);
      });
    }

    /* Click en thumbnail */
    for (var t = 0; t < thumbs.length; t++) {
      thumbs[t].addEventListener('click', function () {
        var idx = parseInt(this.dataset.index, 10);
        showImage(idx);
      });
    }

    /* Swipe en mobile (touch events) */
    if (mainImageWrap) {
      var touchStartX = 0;
      var touchEndX = 0;
      var swipeThreshold = 50;

      mainImageWrap.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      mainImageWrap.addEventListener('touchend', function (e) {
        touchEndX = e.changedTouches[0].screenX;
        var diff = touchStartX - touchEndX;
        if (Math.abs(diff) > swipeThreshold) {
          if (diff > 0) {
            /* Swipe izquierda -> siguiente */
            showImage(currentIndex + 1);
          } else {
            /* Swipe derecha -> anterior */
            showImage(currentIndex - 1);
          }
        }
      }, { passive: true });
    }

    /* Navegacion con teclado en la galeria */
    /* role, aria-label y aria-live ya estan en el HTML */
    if (mainImageWrap) {
      mainImageWrap.setAttribute('tabindex', '0');
      mainImageWrap.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          showImage(currentIndex - 1);
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          showImage(currentIndex + 1);
        }
      });
    }

    /* === SELECTOR DE CANTIDAD === */

    if (minusBtn && qtyInput) {
      minusBtn.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        if (val > 1) {
          qtyInput.value = val - 1;
          updateTotal();
        }
      });
    }

    if (plusBtn && qtyInput) {
      plusBtn.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        var max = parseInt(qtyInput.getAttribute('max'), 10) || 99;
        if (val < max) {
          qtyInput.value = val + 1;
          updateTotal();
        }
      });
    }

    /* Validar input de cantidad (solo numeros positivos) */
    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        var val = parseInt(this.value, 10);
        if (isNaN(val) || val < 1) {
          this.value = 1;
        } else {
          var max = parseInt(this.getAttribute('max'), 10) || 99;
          if (val > max) {
            this.value = max;
          }
        }
        updateTotal();
      });
    }

    /* === ANADIR AL CARRITO SIN REDIRIGIR === */

    var productForm = container.querySelector('.sk-product__form');
    if (productForm) {
      productForm.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!addToCartBtn || addToCartBtn.disabled) return;

        var formData = new FormData(productForm);
        var textoOriginal = addToCartBtn.textContent;
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'Añadiendo...';

        /* Buscar section ID del cart drawer para pedir HTML actualizado */
        var cartItemsComp = document.querySelector('cart-items-component[data-section-id]');
        var sectionId = cartItemsComp ? cartItemsComp.dataset.sectionId : '';
        if (sectionId) formData.append('sections', sectionId);

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          addToCartBtn.textContent = 'Añadido ✓';

          /* Despues de anadir: setear cart.attributes['Fecha de entrega'] con la fecha elegida.
             El JS del cart (sk-delivery.js) hara auto-bump al recalcular min_date si hace falta. */
          var dpInput = container.querySelector('[data-delivery-display]');
          var userDate = dpInput ? dpInput.textContent.replace(/^\s*Entrega el\s+/i, '').trim() : '';
          if (userDate) {
            /* Normalizar: primera letra en mayuscula (formato guardado consistente) */
            userDate = userDate.charAt(0).toUpperCase() + userDate.slice(1);
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ attributes: { 'Fecha de entrega': userDate } }),
            }).catch(function () { /* silencioso: no bloquea el flujo */ });
          }

          /* Actualizar contador del carrito */
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            var counters = document.querySelectorAll('[data-cart-count]');
            for (var c = 0; c < counters.length; c++) {
              counters[c].textContent = cart.item_count;
            }
            /* Disparar evento con secciones para que cart-items-component actualice el HTML.
               itemCount = total real del carrito para que cart-icon.js repinte el badge (sin el, lo lee como 0 y lo oculta). */
            var evt = new CustomEvent('cart:update', {
              bubbles: true,
              detail: { resource: cart, data: { sections: data.sections || {}, itemCount: cart.item_count } }
            });
            document.dispatchEvent(evt);
            /* Abrir cart drawer */
            var drawer = document.querySelector('cart-drawer-component');
            if (drawer && drawer.showDialog) drawer.showDialog();
          });

          setTimeout(function () {
            addToCartBtn.disabled = false;
            addToCartBtn.textContent = textoOriginal;
          }, 1500);
        })
        .catch(function () {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = textoOriginal;
        });
      });
    }

    /* === SELECTOR DE VARIANTES === */

    for (var p = 0; p < pills.length; p++) {
      pills[p].addEventListener('click', function () {
        var variantId = this.dataset.variantId;
        var variantPrice = this.dataset.variantPrice;
        var variantComparePrice = this.dataset.variantComparePrice;
        var variantAvailable = this.dataset.variantAvailable === 'true';

        /* Actualizar pill activa */
        for (var k = 0; k < pills.length; k++) {
          pills[k].classList.remove('sk-product__variant-pill--active');
        }
        this.classList.add('sk-product__variant-pill--active');

        /* Actualizar input hidden de variante */
        if (variantInput) {
          variantInput.value = variantId;
        }

        /* Actualizar precio segun la variante (en centimos) y recomputar el
           total respetando la cantidad seleccionada */
        unitCents = parseInt(this.dataset.variantPriceCents, 10);
        compareCents = this.dataset.variantCompareCents ? parseInt(this.dataset.variantCompareCents, 10) : NaN;

        /* Crear el elemento de precio tachado si la variante lo necesita */
        if (!comparePriceEl && !isNaN(compareCents)) {
          var wrap = container.querySelector('.sk-product__price-wrap');
          if (wrap) {
            var newCompare = document.createElement('span');
            newCompare.className = 'sk-product__price-compare';
            newCompare.setAttribute('data-product-compare-price', '');
            wrap.appendChild(newCompare);
            comparePriceEl = newCompare;
          }
        }
        if (comparePriceEl) {
          comparePriceEl.style.display = isNaN(compareCents) ? 'none' : '';
        }

        updateTotal();

        /* Actualizar estado del boton de carrito (textos desde data-attributes) */
        if (addToCartBtn) {
          var addText = container.dataset.addText || 'anadir a la cesta';
          var soldText = container.dataset.soldText || 'agotado';
          if (variantAvailable) {
            addToCartBtn.disabled = false;
            addToCartBtn.textContent = addText;
          } else {
            addToCartBtn.disabled = true;
            addToCartBtn.textContent = soldText;
          }
        }

        /* Actualizar URL con la variante seleccionada (sin recargar) */
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          window.history.replaceState({}, '', url.toString());
        }
      });
    }

    /* === SELECTOR DE FECHA DE ENTREGA === */

    var deliveryPicker = container.querySelector('[data-delivery-picker]');
    if (deliveryPicker) {
      var DIAS = ['domingo', 'lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];
      var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

      var dpPrepDays = parseInt(deliveryPicker.dataset.prepDays, 10) || 2;
      var dpCutoff = deliveryPicker.dataset.cutoff || '14:00';
      var dpAllowSat = deliveryPicker.dataset.saturday === 'true';
      var dpAllowSun = deliveryPicker.dataset.sunday === 'true';
      var dpCount = parseInt(deliveryPicker.dataset.optionsCount, 10) || 6;
      var dpLabel = deliveryPicker.dataset.label || 'Entrega el';

      var dpToggle = deliveryPicker.querySelector('.sk-product__delivery-toggle');
      var dpDisplay = deliveryPicker.querySelector('[data-delivery-display]');
      var dpPanel = deliveryPicker.querySelector('.sk-product__delivery-panel');
      var dpOptions = deliveryPicker.querySelector('[data-delivery-options]');
      var dpCancel = deliveryPicker.querySelector('[data-delivery-cancel]');
      var dpInput = container.querySelector('[data-delivery-date-input]');

      function dpIsPastCutoff() {
        var now = new Date();
        var parts = dpCutoff.split(':');
        var h = parseInt(parts[0], 10);
        var m = parseInt(parts[1], 10) || 0;
        return now.getHours() > h || (now.getHours() === h && now.getMinutes() >= m);
      }

      function dpIsBusinessDay(d) {
        var day = d.getDay();
        return day >= 1 && day <= 5;
      }

      function dpIsDeliveryDay(d) {
        var day = d.getDay();
        if (day >= 1 && day <= 5) return true;
        if (day === 6 && dpAllowSat) return true;
        if (day === 0 && dpAllowSun) return true;
        return false;
      }

      function dpAddBusinessDays(start, n) {
        var d = new Date(start);
        var added = 0;
        while (added < n) {
          d.setDate(d.getDate() + 1);
          if (dpIsBusinessDay(d)) added++;
        }
        return d;
      }

      function dpFormatDate(d) {
        var name = DIAS[d.getDay()];
        var num = ('0' + d.getDate()).slice(-2);
        var mes = MESES[d.getMonth()];
        return name.charAt(0).toUpperCase() + name.slice(1) + ' ' + num + ' ' + mes;
      }

      function dpIsTomorrow(d) {
        var t = new Date();
        t.setDate(t.getDate() + 1);
        return d.getDate() === t.getDate() && d.getMonth() === t.getMonth() && d.getFullYear() === t.getFullYear();
      }

      /* Calcula las fechas de entrega disponibles */
      function dpCalcDates() {
        var base = new Date();
        base = new Date(base.getFullYear(), base.getMonth(), base.getDate());
        /* Si paso la hora de corte, el pedido cuenta para el dia siguiente */
        if (dpIsPastCutoff()) base.setDate(base.getDate() + 1);
        /* Avanzar al siguiente dia laborable */
        while (!dpIsBusinessDay(base)) base.setDate(base.getDate() + 1);
        /* Sumar dias de preparacion (laborables) */
        var afterPrep = dpAddBusinessDays(base, dpPrepDays);
        /* Recoger fechas de entrega validas */
        var dates = [];
        var d = new Date(afterPrep);
        if (dpIsDeliveryDay(d)) dates.push(new Date(d));
        while (dates.length < dpCount) {
          d.setDate(d.getDate() + 1);
          if (dpIsDeliveryDay(d)) dates.push(new Date(d));
        }
        return dates;
      }

      /* Generar radios y estado inicial */
      var dpDates = dpCalcDates();
      var dpHtml = '';
      for (var di = 0; di < dpDates.length; di++) {
        var dpFmt = dpFormatDate(dpDates[di]);
        var dpTmrw = dpIsTomorrow(dpDates[di]);
        dpHtml += '<label class="sk-product__delivery-option">';
        dpHtml += '<input class="sk-product__delivery-radio" type="radio" name="delivery_date" value="' + dpFmt + '"';
        if (di === 0) dpHtml += ' checked';
        dpHtml += '>';
        dpHtml += '<span class="sk-product__delivery-check"></span>';
        dpHtml += '<span class="sk-product__delivery-date-text">' + dpFmt + '</span>';
        if (dpTmrw) dpHtml += '<span class="sk-product__delivery-badge">Mañana</span>';
        dpHtml += '</label>';
      }
      dpOptions.innerHTML = dpHtml;

      var dpSelected = dpFormatDate(dpDates[0]);
      if (dpDisplay) dpDisplay.textContent = dpLabel + ' ' + dpSelected.toLowerCase();
      if (dpInput) dpInput.value = dpSelected;

      /* Abrir/cerrar panel con animacion max-height */
      function dpOpen() {
        dpToggle.setAttribute('aria-expanded', 'true');
        dpPanel.style.maxHeight = dpPanel.scrollHeight + 'px';
        deliveryPicker.classList.add('sk-product__delivery--open');
      }

      function dpClose() {
        dpToggle.setAttribute('aria-expanded', 'false');
        dpPanel.style.maxHeight = '0';
        deliveryPicker.classList.remove('sk-product__delivery--open');
      }

      if (dpToggle) {
        dpToggle.addEventListener('click', function () {
          var open = dpToggle.getAttribute('aria-expanded') === 'true';
          if (open) dpClose(); else dpOpen();
        });
      }

      /* Al seleccionar una fecha, actualizar display + input y cerrar */
      dpOptions.addEventListener('change', function (e) {
        if (e.target.type === 'radio') {
          dpSelected = e.target.value;
          if (dpDisplay) dpDisplay.textContent = dpLabel + ' ' + dpSelected.toLowerCase();
          if (dpInput) dpInput.value = dpSelected;
          dpClose();
        }
      });

      /* Cancelar: cerrar sin cambios */
      if (dpCancel) {
        dpCancel.addEventListener('click', function () {
          dpClose();
        });
      }

      /* === POPUP DE INFO === */
      var dpInfoBtn = deliveryPicker.querySelector('[data-delivery-info-btn]');
      var dpPopup = deliveryPicker.querySelector('[data-delivery-popup]');

      if (dpInfoBtn && dpPopup && deliveryPicker.dataset.infoShow === 'true') {
        var dpPopupTitle = dpPopup.querySelector('[data-delivery-popup-title]');
        var dpPopupText = dpPopup.querySelector('[data-delivery-popup-text]');
        var dpPopupLink = dpPopup.querySelector('[data-delivery-popup-link]');
        var dpPopupCloseBtn = dpPopup.querySelector('[data-delivery-popup-close]');

        /* Rellenar contenido desde data attributes del metaobjeto */
        if (dpPopupTitle) dpPopupTitle.textContent = deliveryPicker.dataset.infoTitle || '';
        if (dpPopupText) {
          var rawText = deliveryPicker.dataset.infoText || '';
          dpPopupText.innerHTML = rawText.replace(/\n/g, '<br>');
        }
        if (dpPopupLink && deliveryPicker.dataset.infoLinkText) {
          dpPopupLink.textContent = deliveryPicker.dataset.infoLinkText;
          dpPopupLink.href = deliveryPicker.dataset.infoLinkUrl || '#';
          dpPopupLink.style.display = '';
        }

        dpInfoBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          dpPopup.classList.toggle('sk-product__delivery-popup--visible');
        });

        if (dpPopupCloseBtn) {
          dpPopupCloseBtn.addEventListener('click', function () {
            dpPopup.classList.remove('sk-product__delivery-popup--visible');
          });
        }

        /* Cerrar al hacer clic fuera */
        document.addEventListener('click', function (e) {
          if (dpPopup.classList.contains('sk-product__delivery-popup--visible') && !dpPopup.contains(e.target) && !dpInfoBtn.contains(e.target)) {
            dpPopup.classList.remove('sk-product__delivery-popup--visible');
          }
        });
      }
    }

  }

  /* R44: querySelectorAll para encontrar TODAS las instancias */
  var sections = document.querySelectorAll('.sk-product');
  for (var i = 0; i < sections.length; i++) {
    initSection(sections[i]);
  }

  /* R48: re-iniciar en el Customizer */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.sk-product');
    if (section) initSection(section);
  });
})();
